import {getCurrentDeviceView} from 'shared/helpers/utils'

import Smartphones from 'mrshoebox-ui-components/src/components/Charts/Combo/components/Smartphones'
import Tablets from 'mrshoebox-ui-components/src/components/Charts/Combo/components/Tablets'
import './index.scss?global'

const ComboChart = getCurrentDeviceView(Smartphones, Tablets)

export default ComboChart
